<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/184wyd6/tc-custom/9780226729589.jpg?1733104152446" alt="This image is the cover for the book Quality of Government"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Quality of Government
      </h1>
      <p class="bookDescription body article font2">
        <p>The relationship between government, virtue, and wealth has held a special fascination since Aristotle, and the importance of each frames policy debates today in both developed and developing countries. While it’s clear that low-quality government institutions have tremendous negative effects on the health and wealth of societies, the criteria for good governance remain far from clear. In this pathbreaking book, leading political scientist Bo Rothstein provides a theoretical foundation for empirical analysis on the connection between the quality of government and important economic, political, and social outcomes. Focusing on the effects of government policies, he argues that unpredictable actions constitute a severe impediment to economic growth and development—and that a basic characteristic of quality government is impartiality in the exercise of power. This is borne out by cross-sectional analyses, experimental studies, and in-depth historical investigations. Timely and topical, <i>The Quality of Government</i> tackles such issues as political legitimacy, social capital, and corruption.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bo Rothstein
      </h2>
      
      <p class="authorDescription body article"><B>Bo Rothstein</B> is the August Röhss Chair in Political Science at the University of Gothenburg in Sweden. He is the author of several books, including, most recently, <I>Social Traps and the Problem of Trust</I>.<br></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3396f2f2